declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackProdVisSKUAdded = (sku, partName, ymms = '', skuPrice, source) => {
  const event = 'prod_vis_sku_added'

  const logData = {
    event,
    sku,
    partName,
    ymms,
    skuPrice,
    source,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackProdVisSKUAdded
